import { merge as mergeStatic, of } from "rxjs";
import {
    debounceTime,
    distinctUntilChanged,
    filter,
    map,
    mapTo,
    switchMap,
    throttleTime,
} from "rxjs/operators";

import { documentEvent$, windowEvent$ } from "../../utils/any/rxjs";
import { IDLE_TIMEOUT_SECONDS } from "../../utils/config";

// does onActive onIdle part of https://github.com/kidh0/jquery.idle/blob/master/vanilla.idle.js
const interactionEvents$ = mergeStatic(
    [true],
    windowEvent$("mousemove"),
    windowEvent$("mousedown"),
    windowEvent$("touchmove"),
    windowEvent$("touchstart"),
    windowEvent$("keydown").pipe(filter(x => !x.metaKey && !x.altKey && !x.ctrlKey)) // to prevent alt+tab or ctr+pgdown to be counted as interaction
);

// https://coderwall.com/p/cwpdaw/how-to-tell-if-app-page-has-focus and onShow/onHide part of jquery.idle
const focusEvents$ = mergeStatic(
    [document.hasFocus()],
    windowEvent$("focus").pipe(mapTo(true)),
    windowEvent$("blur").pipe(mapTo(false)),
    documentEvent$("visibilitychange").pipe(map(() => !document.hidden))
);

const hadInteraction$ = ((delay, events$) => {
    // https://stackoverflow.com/a/43528807/74167
    const active = events$.pipe(
        throttleTime(delay / 10),
        mapTo(true)
    );
    const idle = events$.pipe(
        debounceTime(delay),
        mapTo(false)
    );
    return mergeStatic(active, idle);
})(IDLE_TIMEOUT_SECONDS, interactionEvents$);

export const isFocused = focusEvents$.pipe(
    switchMap(focus => (focus ? hadInteraction$ : of(false))),
    distinctUntilChanged()
);
